export const accountConstants = {
    SEARCH_REQUEST: 'ACCOUNT_SEARCH_REQUEST',
    SEARCH_SUCCESS: 'ACCOUNT_SEARCH_SUCCESS',
    SEARCH_FAILURE: 'ACCOUNT_SEARCH_FAILURE',
    SEARCH_FAILURE_DONE: 'ACCOUNT_SEARCH_FAILURE_DONE',
};